export enum ServicerTab {
  OVERVIEW = 'overview',
  INVITATIONS = 'invitations',
}
